import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { companyLogo } from '../data/mock';

const Footer = () => {
  const { t } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0f172a] border-t border-[#1e40af] py-12">
      <div className="container mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo & Tagline */}
          <div>
            <img src={companyLogo} alt="Charter Roofings" className="h-12 mb-4" />
            <p className="body-small text-[#94a3b8]">{t.footer.tagline}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-6 text-[#60a5fa] mb-4">{t.nav.services}</h4>
            <nav className="flex flex-col space-y-2">
              <button onClick={() => scrollToSection('services')} className="body-small text-[#94a3b8] hover:text-[#60a5fa] transition-colors text-left">
                {t.nav.services}
              </button>
              <button onClick={() => scrollToSection('projects')} className="body-small text-[#94a3b8] hover:text-[#60a5fa] transition-colors text-left">
                {t.nav.projects}
              </button>
              <button onClick={() => scrollToSection('about')} className="body-small text-[#94a3b8] hover:text-[#60a5fa] transition-colors text-left">
                {t.nav.about}
              </button>
              <button onClick={() => scrollToSection('sponsorship')} className="body-small text-[#94a3b8] hover:text-[#60a5fa] transition-colors text-left">
                {t.nav.sponsorship}
              </button>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="heading-6 text-[#60a5fa] mb-4">{t.nav.contact}</h4>
            <div className="space-y-2">
              <a 
                href="tel:+31623370072" 
                className="body-small text-[#94a3b8] hover:text-[#60a5fa] transition-colors block underline"
              >
                {t.contact.phone}
              </a>
              <a 
                href="mailto:charterroofings@gmail.com" 
                className="body-small text-[#94a3b8] hover:text-[#60a5fa] transition-colors block underline"
              >
                {t.contact.email}
              </a>
              <p className="body-small text-[#60a5fa] font-medium mt-4">{t.contact.emergency}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1e40af] pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="caption text-[#94a3b8] mb-4 md:mb-0">{t.footer.copyright}</p>
          <div className="flex space-x-6">
            <button className="caption text-[#94a3b8] hover:text-[#60a5fa] transition-colors">
              {t.footer.links.privacy}
            </button>
            <button className="caption text-[#94a3b8] hover:text-[#60a5fa] transition-colors">
              {t.footer.links.terms}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
